import { env } from "@/env";

export const FEATURE_FLAGS = {
  imbox: {
    show: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_IMBOX),
  },
  voyadoOnsite: {
    show: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_VOYADO_ONSITE),
  },
  checkout: {
    giftcards: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS),
    adyen: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN),
    walley: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY),
    walleyWidget: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET),
    giftCardChangeButton: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON,
    ),
    madeToOrderNotification: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER,
    ),
    eurobonus: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_EUROBONUS),
    v3: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_CHECKOUT_V3),
  },
  customerService: {
    emailLink: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK,
    ),
    phoneLink: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK,
    ),
    imboxButton: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON,
    ),
  },
  discountPopup: {
    show: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP),
  },
  product: {
    newProductPage: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE,
    ),
    contentfulParametrics: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS,
    ),
    newProductGallery: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY,
    ),
    googleAutomatedDiscounts: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS,
    ),
    fabricSample: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE),
  },
  products: {
    swatches: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES),
    videos: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS),
    staticPages: isFeatureEnabled(
      env.NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES,
    ),
    dynamicPlp: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_DYNAMIC_PLP),
    v2Images: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES),
  },
  marketSelector: {
    new: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR),
  },
  next: {
    prefetch: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_LINK_PREFETCH),
  },
  elevate: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_ELEVATE),
  storeLocator: isFeatureEnabled(env.NEXT_PUBLIC_FEATURES_STORE_LOCATOR),
  fabricSampleShortcut: isFeatureEnabled(
    env.NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT,
  ),
} as const;

function isFeatureEnabled(value?: string) {
  const compare = value?.localeCompare("true", undefined, {
    sensitivity: "accent",
  });

  return compare === 0;
}
